import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", topic: "GENERAL", message: "", privacy: false });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) return toast.error("Töltsd ki a kötelező mezőket");
    if (!form.privacy) return toast.error("Fogadd el az adatkezelési tájékoztatót");
    setLoading(true);
    try {
      await api.post("/contact", form).catch(() => {}); // optional endpoint, fallback graceful
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="kapcsolat" className="section">
      <div className="container-gb contact-grid">
        <div>
          <p className="eyebrow">Kapcsolat</p>
          <h2 className="h-lg">Kérdésed van? Szólj nekünk.</h2>
          <p className="lead muted" style={{ marginTop: 20 }}>Kérdés, gyűjtés, partnerség: írj, és válaszolunk.</p>
          <ul className="contact-list" style={{ marginTop: 32 }}>
            <li><span className="k">Projekt</span><span>GrowBag</span></li>
            <li><span className="k">Helyszín</span><span>Budapest XVII. kerület</span></li>
            <li><span className="k">Email</span><span style={{ userSelect: "all" }}>growbagbudapest@gmail.com</span></li>
          </ul>
        </div>
        {done ? (
          <div className="form-card">
            <p className="eyebrow" style={{ color: "var(--moss)" }}>● Elküldve</p>
            <h3 className="h-md">Köszönjük!</h3>
            <p className="muted" style={{ marginTop: 12 }}>Megkaptuk az üzeneted. Amint tudunk, válaszolunk.</p>
          </div>
        ) : (
          <form className="form-card" onSubmit={submit} noValidate>
            <div className="field">
              <label className="field-label" htmlFor="c-name">Neved</label>
              <input id="c-name" className="input-gb" value={form.name} onChange={(e) => update("name", e.target.value)} maxLength={80} />
            </div>
            <div className="field">
              <label className="field-label" htmlFor="c-email">Email</label>
              <input id="c-email" type="email" className="input-gb" value={form.email} onChange={(e) => update("email", e.target.value)} maxLength={254} />
            </div>
            <div className="field">
              <label className="field-label" htmlFor="c-topic">Miben segíthetünk?</label>
              <select id="c-topic" className="input-gb" value={form.topic} onChange={(e) => update("topic", e.target.value)}>
                <option value="GENERAL">Kérdésem van</option>
                <option value="COLLECTION">Gyűjteném a növényi maradékot — elvinnétek?</option>
                <option value="PARTNER">Partner lennék</option>
              </select>
            </div>
            <div className="field">
              <label className="field-label" htmlFor="c-message">Üzenet</label>
              <textarea id="c-message" className="input-gb" rows={5} maxLength={3000} value={form.message} onChange={(e) => update("message", e.target.value)} />
            </div>
            <label className="check-gb">
              <input type="checkbox" checked={form.privacy} onChange={(e) => update("privacy", e.target.checked)} />
              <span>Elolvastam az <a href="/adatkezeles" target="_blank" rel="noopener">adatkezelési tájékoztatót</a>, és hozzájárulok, hogy adataimat az üzenet megválaszolásához felhasználjátok.</span>
            </label>
            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? "Küldés..." : "Üzenet küldése"} <span className="arrow">→</span>
            </button>
            <p className="muted" style={{ fontSize: ".85rem", margin: "12px 0 0" }}>
              Vagy írj közvetlenül: <span style={{ userSelect: "all", color: "var(--ink)" }}>growbagbudapest@gmail.com</span>
            </p>
          </form>
        )}
      </div>
    </section>
  );
}
